module.exports = __webpack_public_path__ + "fb1976a675c6870bf6227818208ae3de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/microsoft_2023_chart.png
// module id = 1698
// module chunks = 0